import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { usePermissoes } from '../../context/PermissoesContext';   // r87
import ConfiguracoesSistemaModal from '../ConfiguracoesSistemaModal';
import integracaoMsService from '../../services/integracaoMs.service';   // r160


// ─── Mapa path → rotina_codigo (r87 Rodada C) ────────────────────────────────
// Itens cujo path não está aqui são SEMPRE visíveis (ex: Dashboard, Configurações).
const PATH_ROTINA = {
  '/usuarios':                 'usuarios',
  '/grupos-acesso':            'grupos-acesso',
  '/empresas':                 'empresas',
  '/colaboradores':            'colaboradores',
  '/clientes':                 'clientes',
  '/condicoes-pagamento':      'condicoes-pagamento',
  '/crm':                      'crm',
  '/planejamento':             'planejamento',
  '/execucao-tecnica':         'execucao-tecnica',
  '/lancamentos-horas':        'lancamentos-horas',
  '/periodos':                 'periodos',
  '/horarios-colaboradores':   'horarios-colaboradores',
  '/tarefas':                  'tarefas',
  '/acessos':                  'acessos',
};


// ─── Definição dos itens de menu ─────────────────────────────────────────────
// Para adicionar uma nova tela: inclua um item aqui e crie a rota no App.jsx
const MENU = [
  {
    secao: 'PRINCIPAL',
    itens: [
      { label: 'Dashboard', path: '/dashboard', icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <rect x="1" y="1" width="6" height="6" rx="1" fill="currentColor"/>
          <rect x="9" y="1" width="6" height="6" rx="1" fill="currentColor" opacity=".5"/>
          <rect x="1" y="9" width="6" height="6" rx="1" fill="currentColor" opacity=".5"/>
          <rect x="9" y="9" width="6" height="6" rx="1" fill="currentColor" opacity=".5"/>
        </svg>
      )},
    ],
  },
  {
    secao: 'CADASTROS',
    itens: [
      { label: 'Usuários', path: '/usuarios', icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="5" r="3" fill="currentColor"/>
          <path d="M2 13c0-3 2.7-5 6-5s6 2 6 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      )},
      { label: 'Grupos de Acesso', path: '/grupos-acesso', icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="5" cy="5" r="2.5" fill="currentColor" opacity=".6"/>
          <circle cx="11" cy="5" r="2.5" fill="currentColor"/>
          <path d="M1 13c0-2 1.8-3.5 4-3.5M8 13c0-2 1.8-3.5 4-3.5s4 1.5 4 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      )},
      { label: 'Empresas', path: '/empresas', icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <rect x="2" y="4" width="12" height="10" rx="1" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M5 4V3a1 1 0 011-1h4a1 1 0 011 1v1" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M6 9h4M6 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      )},
      { label: 'Colaboradores', path: '/colaboradores', icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="4" r="2.5" fill="currentColor"/>
          <path d="M3 13c0-2.8 2.2-5 5-5s5 2.2 5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M12 7l1.5 1.5L16 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )},
      { label: 'Clientes', path: '/clientes', icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <rect x="1" y="3" width="14" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M1 6h14" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="5" cy="10" r="1" fill="currentColor"/>
        </svg>
      )},
      { label: 'Condições de Pagamento', path: '/condicoes-pagamento', icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <rect x="1" y="4" width="14" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M1 7h14" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M3.5 10.5h2M7 10.5h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      )},
      { label: 'Acessos', path: '/acessos', icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <rect x="3" y="7" width="10" height="7" rx="1" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M6 7V4.5a2 2 0 014 0V7" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="8" cy="10.5" r="1" fill="currentColor"/>
        </svg>
      )},
    ],
  },
  {
    secao: 'COMERCIAL',
    itens: [
      { label: 'CRM — Negócios', path: '/crm', icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M2 12L6 8l3 3 5-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )},
    ],
  },
  {
    secao: 'TÉCNICA',
    itens: [
      { label: 'Planejamento de Projeto', path: '/planejamento', icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          {/* Ícone tipo "checklist com engrenagem" */}
          <rect x="1.5" y="2.5" width="9" height="11" rx="1" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M3.5 5.5h5M3.5 8h5M3.5 10.5h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <circle cx="12.5" cy="11.5" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M12.5 10.5v2M11.5 11.5h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      )},

      // r227: mesmo desenho do iconesRotinas['execucao-tecnica'] (duas
      //       engrenagens), pra o menu e o cabeçalho da tela baterem.
      { label: 'Execução Técnica', path: '/execucao-tecnica', icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          {/* Duas engrenagens vazadas, sobrepostas na diagonal. Os dentes são
              calculados por trigonometria (8 por engrenagem, a cada 45°) — foi
              desenhar diagonal na mão que deixou os ícones anteriores tortos. */}
          <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            {/* Engrenagem menor */}
            <circle cx="7.3" cy="6.6" r="3.2"/>
            <path d="M11.6 6.6L12.8 6.6M10.34 9.64L11.19 10.49M7.3 10.9L7.3 12.1M4.26 9.64L3.41 10.49M3 6.6L1.8 6.6M4.26 3.56L3.41 2.71M7.3 2.3L7.3 1.1M10.34 3.56L11.19 2.71"/>
            {/* Engrenagem maior */}
            <circle cx="16.6" cy="16.4" r="3.9"/>
            <path d="M21.22 18.31L22.42 18.81M18.51 21.02L19.01 22.22M14.69 21.02L14.19 22.22M11.98 18.31L10.78 18.81M11.98 14.49L10.78 13.99M14.69 11.78L14.19 10.58M18.51 11.78L19.01 10.58M21.22 14.49L22.42 13.99"/>
          </g>
        </svg>
      )},

{
  label: 'Lançamento de Horas',
  path: '/lancamentos-horas',
  icon: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      {/* Caixa do relógio */}
      <circle cx="8" cy="8" r="4.5" stroke="currentColor" strokeWidth="1.5"/>
      {/* Pulseira superior */}
      <path d="M5.5 3.5L6 1h4l0.5 2.5" stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round"/>
      {/* Pulseira inferior */}
      <path d="M5.5 12.5L6 15h4l0.5-2.5" stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round"/>
      {/* Ponteiros (12 → 3) */}
      <path d="M8 6v2l1.5 1" stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
},

   ],
  },
  {
    secao: 'TAREFAS',
    itens: [
      { label: 'Tarefas e Pendências', path: '/tarefas', icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          {/* Checklist com check */}
          <rect x="2" y="2" width="12" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M5 8l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )},
    ],
  },
  {
    secao: 'SISTEMA',
    adminOnly: true,                    // r158: seção inteira só pra Administrador
    itens: [
      // Item especial: ao clicar abre o modal de Configurações em vez de navegar
      { label: 'Configurações do Sistema', acao: 'config', icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.5 3.5l1.4 1.4M11.1 11.1l1.4 1.4M3.5 12.5l1.4-1.4M11.1 4.9l1.4-1.4"
                stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      )},
      { label: 'Horários por Colaborador', path: '/horarios-colaboradores', icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M8 4v4l2.5 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      )},
{
  label: 'Períodos de Lançamentos',
  path: '/periodos',
  icon: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      {/* Calendário com indicador de "fechado" */}
      <rect x="1.5" y="3" width="13" height="11" rx="1.5"
            stroke="currentColor" strokeWidth="1.5"/>
      <path d="M1.5 6.5h13" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M5 1.5v3M11 1.5v3" stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round"/>
      {/* Cadeado mini (representando fechamento) */}
      <rect x="6.5" y="9" width="3" height="2.5" rx="0.3"
            stroke="currentColor" strokeWidth="1.2"/>
      <path d="M7 9V8.2a1 1 0 011-1 1 1 0 011 1V9" stroke="currentColor"
            strokeWidth="1.2"/>
    </svg>
  ),
},
    ],
  },
];

// ─── Estilos ──────────────────────────────────────────────────────────────────
const S = {
  sidebar: (collapsed) => ({
    width: collapsed ? '52px' : '220px',
    minWidth: collapsed ? '52px' : '220px',
    backgroundColor: '#003399',
    display: 'flex',
    flexDirection: 'column',
    transition: 'width 0.25s ease, min-width 0.25s ease',
    overflow: 'hidden',
    height: '100vh',
    position: 'fixed',
    left: 0,
    top: 0,
    zIndex: 100,
    fontFamily: "'Manrope', sans-serif",
  }),
  header: {
    padding: '16px 14px 12px',
    borderBottom: '1px solid rgba(255,255,255,0.1)',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  logoIcon: {
    width: '28px', height: '28px', minWidth: '28px',
    backgroundColor: '#fff',
    borderRadius: '6px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  logoIconText: { color: '#003399', fontSize: '13px', fontWeight: '700' },
  // Estilo da imagem da logo quando o sidebar está expandido (logo completa)
  logoFullImg: {
    height: '28px',
    width: 'auto',
    maxWidth: '160px',
    objectFit: 'contain',
    display: 'block',
  },
  // Estilo da imagem do favicon quando o sidebar está recolhido (só o "A")
  logoIconImg: {
    width: '28px',
    height: '28px',
    objectFit: 'contain',
    display: 'block',
  },
  logoText: (collapsed) => ({
    color: '#fff', fontSize: '15px', fontWeight: '600',
    opacity: collapsed ? 0 : 1,
    transition: 'opacity 0.2s',
    whiteSpace: 'nowrap',
  }),
  // Recolhido: esconde a barra de rolagem — no Windows ela come ~17px dos 52px
  // e empurra os ícones pra fora da área visível.
  nav: (collapsed) => ({
    flex: 1, padding: '8px 0', overflowY: 'auto', overflowX: 'hidden',
    scrollbarWidth: collapsed ? 'none' : 'auto',
  }),
  secao: (collapsed) => ({
    padding: '12px 14px 4px',
    fontSize: '10px', fontWeight: '600',
    color: 'rgba(255,255,255,0.4)',
    letterSpacing: '0.8px',
    whiteSpace: 'nowrap',
    opacity: collapsed ? 0 : 1,
    transition: 'opacity 0.15s',
  }),
  // Recolhido: ícone centralizado nos 52px, sem padding lateral
  item: (ativo, collapsed) => ({
    display: 'flex', alignItems: 'center', gap: '10px',
    justifyContent: collapsed ? 'center' : 'flex-start',
    padding: collapsed ? '9px 0' : '9px 14px',
    cursor: 'pointer',
    color: ativo ? '#fff' : 'rgba(255,255,255,0.75)',
    fontSize: '13px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    backgroundColor: ativo ? 'rgba(255,255,255,0.12)' : 'transparent',
    borderLeft: ativo ? '3px solid #fff' : '3px solid transparent',
    transition: 'background 0.15s, color 0.15s',
    userSelect: 'none',
  }),
  // Recolhido: label sai do fluxo (display none) — se só ficasse invisível,
  // o texto em nowrap continuava ocupando espaço e espremia o ícone até sumir.
  itemLabel: (collapsed) => ({
    display: collapsed ? 'none' : 'inline',
    opacity: collapsed ? 0 : 1,
    transition: 'opacity 0.15s',
    whiteSpace: 'nowrap',
  }),
  // r160: bloco de conexão Microsoft (acima do footer)
  msIntegracao: (conectado, collapsed) => ({
    padding: collapsed ? '10px' : '10px 14px',
    borderTop: '1px solid rgba(255,255,255,0.1)',
    display: 'flex', alignItems: 'center', gap: '10px',
    whiteSpace: 'nowrap', overflow: 'hidden',
    cursor: 'pointer',
    backgroundColor: conectado ? 'rgba(16,185,129,0.12)' : 'transparent',
    transition: 'background-color 0.15s',
    color: '#fff',
  }),
  msIcon: {
    width: '24px', height: '24px', minWidth: '24px',
    borderRadius: '4px',
    backgroundColor: 'rgba(255,255,255,0.95)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '4px',
  },
  footer: {
    padding: '12px 14px',
    borderTop: '1px solid rgba(255,255,255,0.1)',
    display: 'flex', alignItems: 'center', gap: '10px',
    whiteSpace: 'nowrap', overflow: 'hidden',
    cursor: 'pointer',
  },
  avatar: {
    width: '30px', height: '30px', minWidth: '30px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255,255,255,0.2)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: '#fff', fontSize: '12px', fontWeight: '600',
  },
  userInfo: (collapsed) => ({
    overflow: 'hidden',
    opacity: collapsed ? 0 : 1,
    transition: 'opacity 0.15s',
  }),
  userName: { color: '#fff', fontSize: '13px', fontWeight: '500' },
  userRole: { color: 'rgba(255,255,255,0.5)', fontSize: '11px' },
};

// ─── Componente ───────────────────────────────────────────────────────────────
function Sidebar({ collapsed, onToggle }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { usuario, logout } = useAuth();
  const { pode, isAdmin, isBootstrap } = usePermissoes();
  const [configModalAberto, setConfigModalAberto] = useState(false);

  // r160: estado da integração Microsoft (conectado, email, etc)
  const [msStatus, setMsStatus] = useState({ conectado: false });

  useEffect(() => {
    if (!usuario?.id) return;
    integracaoMsService.status().then(setMsStatus).catch(() => setMsStatus({ conectado: false }));

    // Detecta retorno do callback Microsoft (querystring ?ms_conectado=1)
    const qs = new URLSearchParams(window.location.search);
    if (qs.get('ms_conectado') === '1') {
      // Recarrega o status
      integracaoMsService.status().then(setMsStatus);
      // Limpa querystring sem recarregar
      window.history.replaceState({}, '', window.location.pathname);
    }
    if (qs.get('ms_erro')) {
      console.warn('Falha ao conectar Microsoft:', qs.get('ms_erro'));
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [usuario]);

  const handleConectarMs = () => {
    if (!usuario?.id) return;
    window.location.href = integracaoMsService.urlIniciar(usuario.id);
  };

  const handleDesconectarMs = async () => {
    if (!window.confirm('Desconectar do Microsoft 365? A sincronização do calendário será interrompida.')) return;
    try {
      await integracaoMsService.desconectar();
      setMsStatus({ conectado: false });
    } catch (err) {
      console.error(err);
      alert('Erro ao desconectar: ' + (err.response?.data?.mensagem || err.message));
    }
  };
  

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleClickItem = (item) => {
    // Item especial com `acao`: dispara handler interno (não navega)
    if (item.acao === 'config') {
      // r158: defesa extra — não abre o modal se não for admin
      if (!isAdmin && !isBootstrap) return;
      setConfigModalAberto(true);
      return;
    }
    if (item.path) navigate(item.path);
  };

const podeVerItem = (item) => {
  // r158: item ou seção inteira marcada como adminOnly bloqueia não-admins
  if (item.adminOnly && !(isAdmin || isBootstrap)) return false;
  if (isAdmin || isBootstrap) return true;
  if (!item.path) return true;
  const rotina = PATH_ROTINA[item.path];
  if (!rotina) return true;
  return pode(rotina, 'visualizar');
};

const MENU_FILTRADO = MENU
  // r158: remove seções marcadas como adminOnly de não-admins
  .filter(grupo => !grupo.adminOnly || isAdmin || isBootstrap)
  .map(grupo => ({ ...grupo, itens: grupo.itens.filter(podeVerItem) }))
  .filter(grupo => grupo.itens.length > 0);

  // Iniciais do nome amigável para o avatar (fallback se não tiver foto)
  const iniciais = (usuario?.nomeAmigavel || 'U')
    .split(' ')
    .map(p => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  // r115/r125: URL absoluta da foto (se houver).
  // Monta usando o MESMO host do navegador — funciona em qualquer máquina.
  const fotoUrl = (() => {
    if (!usuario?.foto) return '';
    if (usuario.foto.startsWith('http')) return usuario.foto;
    const base = process.env.REACT_APP_API_BASE ? process.env.REACT_APP_API_BASE.replace(/\/api$/, '') : '';
    return `${base}${usuario.foto}`;
  })();

  return (
    <div style={S.sidebar(collapsed)}>
      {/* Logo */}
      <div style={S.header}>
        {collapsed ? (
          // Quando recolhido, mostra só o ícone do "A" da logo
          <img
            src="/favicon.svg"
            alt="Alpha ERP"
            style={S.logoIconImg}
          />
        ) : (
          // Quando expandido, mostra a logo completa (A + alpha + ERP)
          <img
            src="/alpha-logo.svg"
            alt="Alpha ERP"
            style={S.logoFullImg}
          />
        )}
      </div>

      {/* Navegação */}
      <nav style={S.nav(collapsed)}>
        {MENU_FILTRADO.map((grupo) => (
          <div key={grupo.secao}>
            <div style={S.secao(collapsed)}>{grupo.secao}</div>
            {grupo.itens.map((item) => {
              const ativo = item.path && location.pathname === item.path;
              return (
                <div
                  key={item.path || item.acao || item.label}
                  style={S.item(ativo, collapsed)}
                  onClick={() => handleClickItem(item)}
                  title={collapsed ? item.label : ''}
                  onMouseEnter={e => {
                    if (!ativo) e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.08)';
                  }}
                  onMouseLeave={e => {
                    if (!ativo) e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  <span style={{ display: 'inline-flex', flexShrink: 0 }}>{item.icon}</span>
                  <span style={S.itemLabel(collapsed)}>{item.label}</span>
                </div>
              );
            })}
          </div>
        ))}
      </nav>

      {/* Menu retrátil: expandido = ícone + descrição; recolhido = só ícone */}
      <div
        style={{ ...S.item(false, collapsed), borderTop: '1px solid rgba(255,255,255,0.1)' }}
        onClick={onToggle}
        title={collapsed ? 'Expandir menu' : ''}
        onMouseEnter={e => { e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.08)'; }}
        onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" strokeWidth="2"
             strokeLinecap="round" strokeLinejoin="round"
             style={{ minWidth: '16px', transform: collapsed ? 'rotate(180deg)' : 'none', transition: 'transform 0.25s' }}>
          <polyline points="11 17 6 12 11 7" />
          <polyline points="18 17 13 12 18 7" />
        </svg>
        <span style={S.itemLabel(collapsed)}>Recolher menu</span>
      </div>

      {/* r160: Conexão com Microsoft 365 (logo acima do rodapé) */}
      <div
        onClick={msStatus.conectado ? handleDesconectarMs : handleConectarMs}
        title={msStatus.conectado
          ? `Conectado como ${msStatus.ms_email || msStatus.ms_nome}\nClique pra desconectar`
          : 'Conectar com Microsoft 365 (sincroniza calendário)'}
        style={S.msIntegracao(msStatus.conectado, collapsed)}
      >
        <span style={S.msIcon}>
          {/* "Janela" do logo Microsoft em 4 quadradinhos */}
          <span style={{ display: 'inline-grid', gridTemplateColumns: '1fr 1fr', gap: '1px', width: '14px', height: '14px' }}>
            <span style={{ background: '#f35325' }} />
            <span style={{ background: '#81bc06' }} />
            <span style={{ background: '#05a6f0' }} />
            <span style={{ background: '#ffba08' }} />
          </span>
        </span>
        {!collapsed && (
          <div style={{ flex: 1, overflow: 'hidden' }}>
            <div style={{ fontSize: '12px', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {msStatus.conectado ? 'Microsoft conectado' : 'Conectar Microsoft'}
            </div>
            {msStatus.conectado && msStatus.ms_email && (
              <div style={{ fontSize: '10px', opacity: 0.7, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {msStatus.ms_email}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Rodapé com usuário */}
      <div style={S.footer} onClick={handleLogout} title="Sair do sistema">
        {/* r115: avatar com foto se tiver; fallback iniciais */}
        <div style={{
          ...S.avatar,
          backgroundImage: fotoUrl ? `url(${fotoUrl})` : 'none',
          backgroundSize: 'cover', backgroundPosition: 'center',
        }}>
          {!fotoUrl && iniciais}
        </div>
        <div style={S.userInfo(collapsed)}>
          <div style={S.userName}>{usuario?.nomeAmigavel || 'Usuário'}</div>
          <div style={S.userRole}>{usuario?.grupo || 'Sair'}</div>
        </div>
      </div>

      {/* Modal de Configurações do Sistema (aberto pelo item de menu) */}
      <ConfiguracoesSistemaModal
        aberto={configModalAberto}
        usuario={usuario}
        onFechar={() => setConfigModalAberto(false)}
      />
    </div>
  );
}

export default Sidebar;
export { MENU };
